import React, { Component } from "react"
import PropTypes from "prop-types"
import Highcharts from "highcharts"
import { translate } from "react-i18next"
import HighchartsMore from "highcharts/highcharts-more"
import SolidGauge from "highcharts/modules/solid-gauge.src"
import Exporting from "highcharts/modules/exporting"
import { CHARTS } from "../../../constants"

class DoughnutChart extends Component {
  componentDidMount = () => {
    const {
      data,
      prefix,
      suffix,
      chartThreshold,
      t,
      hasComparison,
      titleKey,
      labelKey,
      subtitleKey
    } = this.props
    const colours = [CHARTS.getRandomColour(titleKey)]
    const selectedColour = colours[0]

    // Get the element into which to insert the chart
    const chartContainer = this.chartContainerRef

    // Build the chartText to put as the tooltip
    const labelText = labelKey
      ? `<div style='text-align: center; font-size:1em; text-transform: uppercase; margin-top: -10px; font-weight: normal;'>${t(labelKey)}</div>`
      : ""

    const chartText = `<span style='font-size:3.4em; font-weight: bold'>${prefix ||
      ""}{point.y}${suffix || ""}</span>${labelText}`

    // Initialise high charts more and SolidGauge as they are required
    // for this chart type.
    HighchartsMore(Highcharts)
    SolidGauge(Highcharts)
    Exporting(Highcharts)

    const chartHeight = hasComparison ? 275 : CHARTS.standardHeight

    // Create the chart
    this.chart = new Highcharts.Chart({
      chart: {
        renderTo: chartContainer,
        height: chartHeight,
        type: "solidgauge",
      },
      lang: {
        contextButtonTitle: t("Common.ChartDownloadOptions"),
      },
      credits: {
        enabled: false,
      },
      colors: colours,
      title: {
        text: titleKey != null && titleKey.length > 0 ? t(titleKey) : null,
        y: -30
      },
      subtitle: {
        text: subtitleKey != null && subtitleKey.length > 0 ? t(subtitleKey) : null,
        y: -15
      },
      tooltip: {
        enabled: false,
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [
          {
            outerRadius: "100%",
            innerRadius: "80%",
            backgroundColor: Highcharts.Color(selectedColour)
              .setOpacity(0.3)
              .get(),
            borderWidth: 0,
          },
        ],
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false,
          },
          linecap: "round",
          stickyTracking: false,
          animation: CHARTS.animationEnabled,
          threshold: chartThreshold,
        },
      },
      series: [
        {
          name: data[0].itemName,
          data: [
            {
              radius: "100%",
              innerRadius: "80%",
              y: data[0].value,
            },
          ],
          dataLabels: {
            color: selectedColour,
            enabled: true,
            format: chartText,
            y: -6,
            borderWidth: 0,
            useHTML: true,
            verticalAlign: "middle",
          },
        },
      ],
      exporting: {
        enabled: CHARTS.exportEnabled,
        buttons: {
          contextButton: {
            menuItems: CHARTS.exportButtons,
          },
        },
        filename: titleKey != null && titleKey.length > 0 ? t(titleKey) : null,
        chartOptions: CHARTS.exportChartOptions
      },
    })
  }

  componentWillUnmount = () => {
    this.chart.destroy()
  }

  render() {
    // Set the widget width: 1, 2 or 3 thirds
    const { columns, children } = this.props
    let gridColClassName = ""
    switch (columns) {
      case -3:
        gridColClassName = "col-lg-3"
        break
      case 1:
        gridColClassName = "col-lg-4"
        break
      case 2:
        gridColClassName = "col-lg-8"
        break
      default:
        gridColClassName = "col-lg-12"
        break
    }

    return (
      <div className={`chart-container ${gridColClassName} col-md-12`}>
        <div
          ref={(c) => {
            this.chartContainerRef = c
          }}
        />
        {children}
      </div>
    )
  }
}

DoughnutChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    itemName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
  hasComparison: PropTypes.bool.isRequired, // If false, the chart height gets increased
  suffix: PropTypes.string,
  prefix: PropTypes.string,
  chartThreshold: PropTypes.number,
  columns: PropTypes.number,
  children: PropTypes.node,
  t: PropTypes.func.isRequired,
  titleKey: PropTypes.string,
  labelKey: PropTypes.string,
  subtitleKey: PropTypes.string
}

DoughnutChart.defaultProps = {
  columns: 3,
  labelKey: null,
  suffix: null,
  prefix: null,
  chartThreshold: null,
  children: null,
  titleKey: "",
  subtitleKey: ""
}

export default translate()(DoughnutChart)



// WEBPACK FOOTER //
// ./src/components/charts/generic/DoughnutChart.jsx